import { type PathLookupDecisionEvent, isNonNullable } from '@ipfabric/utils';

import type { RequiredBy } from '@ipfabric/utils/types/RequiredBy';

export const isSeverityEvent = (
  event: PathLookupDecisionEvent,
): event is RequiredBy<PathLookupDecisionEvent, 'severityInfo'> =>
  isNonNullable(event.severityInfo);
